import { trackEvent } from '@/utils/analytics'

/**
 * Marketplace quote-funnel analytics (MAR-993).
 *
 * PostHog funnel: 24.5k marketplace pageviews/4wks but only 104 (0.4%) reach
 * /marketplace/quote. These helpers instrument every "Get a quote" / "Add to
 * Quote" CTA at the point of price display, plus the quote form submit, so the
 * funnel can be measured per product + segment + surface.
 *
 * Events fire through `trackEvent` (PostHog capture; no ad-platform config is
 * registered for them in EVENT_CONFIG, so they are PostHog-only by design).
 */

/** Where the CTA was rendered — one value per price-display surface. */
export type QuoteCtaSurface =
  | 'pricing_by_segment_tab' // "Pricing by Segment" tab rows (ProductDetailTabs)
  | 'product_sidebar' // compact QuantityAndAddToQuote quote box in the product and segment page header
  | 'product_inline' // inline QuantityAndAddToQuote variant
  | 'calculator' // license calculator quote modal

export const MARKETPLACE_QUOTE_CTA_CLICKED = 'marketplace_quote_cta_clicked'
export const MARKETPLACE_QUOTE_SUBMITTED = 'marketplace_quote_submitted'

/** Canonical quote-page URL carrying product + segment attribution/prefill params. */
export function buildQuoteUrl(productSlug: string, segment: string): string {
  return `/marketplace/quote?product=${encodeURIComponent(productSlug)}&segment=${encodeURIComponent(segment)}`
}

export function trackQuoteCtaClicked(props: {
  product: string
  segment: string
  surface: QuoteCtaSurface
}): void {
  trackEvent(MARKETPLACE_QUOTE_CTA_CLICKED, props)
}

export function trackQuoteSubmitted(props: {
  surface: 'quote_page' | 'calculator'
  products: string[]
  segments: string[]
  item_count: number
  license_count: number
  monthly_total: number
  annual_total: number
  schedule_call?: boolean
  hubspot_success?: boolean
}): void {
  trackEvent(MARKETPLACE_QUOTE_SUBMITTED, props)
}
